import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-37d705a0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_2 = {
  style: {
    "padding-right": "20px"
  }
};
const _hoisted_3 = {
  class: "el-dropdown-link",
  style: {
    "text-align": "center"
  }
};
const _hoisted_4 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_5 = {
  style: {
    "flex": "1"
  }
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex": "1"
  }
}, null, -1));
import { reactive, ref } from 'vue';
import { useStore } from 'vuex';
import { updatePasswordByUser } from '@/api/loginApi';
import { useRouter } from 'vue-router';
import SystemDialog from '@/components/system/SystemDialog.vue';
import { ElMessage } from 'element-plus';
export default /*#__PURE__*/_defineComponent({
  __name: 'avatar',
  setup(__props) {
    const visible = ref(false);
    const title = ref('修改密码');
    const store = useStore();
    const router = useRouter();
    const username = store.getters.name;
    const userId = store.getters.userId;
    const squareUrl = ref('https://img0.baidu.com/it/u=1056811702,4111096278&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500');
    const userModel = reactive({
      id: '',
      password: ''
    });
    const logout = () => {
      try {
        // store.dispatch('login/logout')
        // 清除 Vuex 中的登录状态
        store.commit('login/setToken', '');
        store.commit('login/setRemoveTab', []);
        // localStorage.clear()
        // 清除本地存储
        localStorage.removeItem('tokenTime');
        localStorage.removeItem('token');
        localStorage.removeItem('UAccessToken');
        localStorage.removeItem('URefreshToken');
        localStorage.removeItem('UExpireTime');
        sessionStorage.clear();
        router.replace('/login');
        // window.location.href = 'http://127.0.0.1:8080/#/login' // 不建议这通常不是 Vue 应用的推荐做法，因为它绕过了 Vue Router 的管理
        // window.location.href = config.loginUrl
      } catch (error) {
        console.log(error);
      }
    };
    const updatePassword = async () => {
      visible.value = true;
    };
    const toPerson = () => {
      router.push('/person/person');
    };
    const onClose = () => {
      visible.value = false;
    };
    const onConfirm = async () => {
      const res = await updatePasswordByUser(userId, userModel.password);
      if (res.code === 200) {
        ElMessage({
          message: '修改成功,重新登录',
          type: 'success'
        });
        visible.value = false;
        localStorage.clear();
        sessionStorage.clear();
        router.replace('/login');
      } else {
        ElMessage({
          message: '修改失败',
          type: 'warning'
        });
      }
    };
    // 表单验证规则
    const rules = reactive({
      password: [{
        required: true,
        trigger: 'blur',
        message: '请输入新的密码'
      }]
    });
    return (_ctx, _cache) => {
      const _component_el_avatar = _resolveComponent("el-avatar");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_dropdown, null, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
            onClick: toPerson
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('personal.personal')), 1)]),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            onClick: updatePassword
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('personal.password')), 1)]),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            onClick: logout
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('personal.quit')), 1)]),
            _: 1
          })]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", _hoisted_2, _toDisplayString(_unref(username)), 1), _createElementVNode("span", _hoisted_3, [_createVNode(_component_el_avatar, {
          shape: "square",
          size: 40,
          src: squareUrl.value
        }, null, 8, ["src"])])])]),
        _: 1
      }), _createVNode(SystemDialog, {
        modelValue: visible.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => visible.value = $event),
        title: title.value,
        height: "250",
        width: "50%",
        onOnClose: onClose,
        onOnConfirm: onConfirm
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form, {
          rules: rules,
          "label-width": "120px",
          inline: true,
          model: userModel,
          ref: "ruleFormRef"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_form_item, {
            label: "新的密码",
            class: "item_iput",
            prop: "password"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: userModel.password,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => userModel.password = $event),
              placeholder: "请输入新的密码"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]), _hoisted_6])]),
          _: 1
        }, 8, ["rules", "model"])]),
        _: 1
      }, 8, ["modelValue", "title"])], 64);
    };
  }
});